export const environmentNameResolver = (url: string): string => {
  if (url.indexOf('//www.fido.ca') > -1) {
    return 'prod';
  }
  if (url.indexOf('preprod') > -1 || url.indexOf('staging') > -1) {
    return 'staging';
  }
  if (/\/\/(www.)?(qa|dev|pet|env)/.test(url)) {
    return url.replace(/.*((qa|dev|pet|env)\d*).*/, '$1');
  }
  if (url.indexOf('//fss-qa') > -1) {
    return url.replace(/.*(fss-qa\d*).*/, '$1').replace(/.*(qa\d*).*/, '$1');
  }
  if (url.indexOf('//fss-dev') > -1) {
    return url.replace(/.*(fss-dev\d*).*/, '$1');
  }
  if (url.indexOf('//localhost.') > -1) {
    return 'default';
  }
  return 'qa';
};
